var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlucoseManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C8078;}\n\t.st1{fill:#E6393D;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#F2F2F2;}\n\t.st4{fill:#E5E5E5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.6,182.5c42.7,0,77.3-34.3,77.3-76.6s-34.6-76.6-77.3-76.6s-77.3,34.3-77.3,76.6 C29.3,148.2,63.9,182.5,106.6,182.5"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.7,51.6c-0.3,0.4-0.6,0.8-0.8,1c-10.6,16.5-21.3,32.8-31.8,49.3c-3.2,5-5,10.8-5.5,16.8 c-2,24.2,18.6,44,42.8,41.1c27.9-3.4,42.8-35.1,27.4-58.7c-3.7-5.7-7.4-11.5-11.1-17.2C120.5,73.2,113.7,62.6,106.7,51.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.7,51.6c7.1,11,14,21.6,20.9,32.3c3.7,5.7,7.4,11.5,11.1,17.2c15.3,23.5,0.6,55.3-27.4,58.7 c-24.2,2.9-44.7-16.9-42.8-41.1c0.4-6,2.2-11.6,5.5-16.8c10.6-16.5,21.3-32.8,31.8-49.3C106,52.4,106.2,52.2,106.7,51.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 109.5,
    className: "st2",
    width: 32.1,
    height: 32.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "84,109.5 94,98.4 126.3,98.4 116.3,109.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "116.3,141.7 116.3,109.5 126.3,98.4 126.3,130.6  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlucoseManagement);
export default __webpack_public_path__ + "static/media/Glucose_Management.7469338baad9fb5cab50991b80673adf.svg";
export { ForwardRef as ReactComponent };